import React from 'react';
import { Slide, toast } from 'react-toastify';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../DesignSystem/LiliCloseButton/CloseButton';

export const ToastOptions = {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 3000,
  hideProgressBar: true,
  transition: Slide,
  closeButton: <CloseButton className='absolute right-1 top-1' id='toast-close-button' size={CloseButtonSize.Small} color={CloseButtonColor.White} />,
  limit: 1,
};
